// templates-api.js
import { ProtectedHttpClient } from "../shared/clients/http-client";

const TemplatesApi = {
  private: {
    getAllExternalTemplates: ({ page = 1, limit = 10 }) =>
      ProtectedHttpClient.post(`/message-templates?page=${page}&limit=${limit}`, {
        applicableFor: ["external"]
      }),
    
    // Create a new external template
    createExternalTemplate: (templateData) =>
      ProtectedHttpClient.post('/message-template/twilio', templateData),
    
    // Update an existing external template
    updateExternalTemplate: (templateId, templateData) =>
      ProtectedHttpClient.patch(`/message-template/${templateId}/twilio`, templateData),
    
    // Get a single external template by ID
    getExternalTemplate: (templateId) => 
      ProtectedHttpClient.get(`/api/v1/message-template/${templateId}/twilio`),
    
    // Check Twilio approval status for a template
    checkTwilioApprovalStatus: (templateId) =>
      ProtectedHttpClient.get(`/message-template/${templateId}/approval-status`),
    
    // Get analytics for a template
    getTemplateAnalytics: ({ templateId, startDate, endDate, status, page = 1, limit = 20 }) =>
      ProtectedHttpClient.post(`/message-template/${templateId}/analytics`, {
        startDate, endDate, status, page, limit
      }),

    // Export all analytics records for a template (no pagination)
    exportTemplateAnalytics: ({ templateId, startDate, endDate, status }) =>
      ProtectedHttpClient.post(`/message-template/${templateId}/analytics/export`, {
        startDate, endDate, ...(status ? { status } : {}),
      }),

    // Delete an external template - to be implemented when endpoint is provided
    // deleteExternalTemplate: (templateId) => ProtectedHttpClient.delete(`/api/v1/message-template/${templateId}/twilio`),
  },
};

export default TemplatesApi;
